import { CalendarClock, Crown, Zap } from "lucide-react";
import { PERIOD_LABEL } from "@/lib/recruiter";

const fmt = (d) => (d ? new Date(d).toLocaleDateString([], { dateStyle: "medium" }) : "");

export const AllowanceCard = ({ me }) => {
  const a = me.allowance || {};
  const extra = a.bonus || 0;
  return (
    <div className="rounded-2xl border border-[#8224e3]/40 bg-[#121214] p-5" data-testid="recruiter-allowance">
      <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d7b6ff]">Your recruiter time</p>
      {a.included ? <>
        <p className="mt-2 font-display text-4xl text-zinc-50" data-testid="recruiter-remaining">{a.remaining ?? "—"}<span className="ml-1 text-base text-zinc-500">/ {a.included + extra}</span></p>
        <p className="text-sm text-zinc-400">{a.duration_min}-minute session{a.included + extra > 1 ? "s" : ""} left {PERIOD_LABEL[a.period]}</p>
        {a.resets_at && <p className="mt-2 flex items-center gap-1.5 text-xs text-zinc-500" data-testid="recruiter-resets"><CalendarClock className="h-3.5 w-3.5" />Resets {fmt(a.resets_at)}</p>}
        {a.priority && <p className="mt-2 flex items-center gap-1.5 text-xs text-[#F3C649]" data-testid="recruiter-priority"><Crown className="h-3.5 w-3.5" />Priority booking: Elite members see the earliest open times first</p>}
        {extra > 0 && <p className="mt-1 flex items-center gap-1.5 text-xs text-emerald-300"><Zap className="h-3.5 w-3.5" />{extra} bonus session{extra > 1 ? "s" : ""} added by our team</p>}
      </> : <p className="mt-2 text-sm text-zinc-400" data-testid="recruiter-no-allowance">1:1 recruiter sessions are included with Pro (15 min each quarter) and Elite (30 min every month).</p>}
      {me.pending && <p className="mt-3 text-[11px] text-zinc-600" data-testid="recruiter-pending">Your exact allowance is confirmed when you book.</p>}
    </div>
  );
};
